import { MouseEventHandler } from 'react';
import Button from '../Button';
import Eye from 'mdi-material-ui/Eye';
import EyeOff from 'mdi-material-ui/EyeOff';
import useStyles from './styles';

const PasswordToggle = (props: PasswordToggleProps) => {
  const { classes } = useStyles();
  const { showPasswords, toggleShowPasswords, ...rest } = props;

  return (
    <Button variant="text" onClick={toggleShowPasswords} {...rest}>
      {showPasswords ? (
        <>
          <EyeOff className={classes.toggleEyeIcon} />
          Hide Passwords
        </>
      ) : (
        <>
          <Eye className={classes.toggleEyeIcon} />
          Show Passwords
        </>
      )}
    </Button>
  );
};

export type PasswordToggleProps = {
  showPasswords: boolean;
  toggleShowPasswords: MouseEventHandler;
};

export default PasswordToggle;
